module.exports = __webpack_public_path__ + "img/13.e6340e57.jpg";